import React, { useEffect, useRef } from 'react'
import AboutIntro from '../components/AboutIntro'
import Fondateurs from '../components/Fondateurs'
import Innovation from '../components/Innovation'
import Investissement from '../components/Investissement'
import Terrain from '../components/Terrain'
import FooterPage from '../components/FooterPage'

const AboutUs = () => {
  const topRef = useRef<HTMLDivElement>(null)
  useEffect(() =>{
      if(topRef){
        window.scrollTo(0,0)
      }
  },[])

  return (
  <div ref={topRef}>
    <AboutIntro/>
    <Fondateurs/>
    <Terrain/>
    <Innovation/>
    <Investissement/>
    <FooterPage/>
  </div>
  )
}

export default AboutUs
